import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { Toaster } from "@/components/ui/sonner";
import { Home } from "@/pages/Home";
import { CapabilityDetail } from "@/pages/CapabilityDetail";
import { Blog } from "@/pages/Blog";
import { BlogPost } from "@/pages/BlogPost";
import { Contact } from "@/pages/Contact";
import { QualityProcess } from "@/pages/QualityProcess";
import { GlobalNetwork } from "@/pages/GlobalNetwork";
import { About } from "@/pages/About";
import { Careers } from "@/pages/Careers";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/capabilities/:slug" element={<CapabilityDetail />} />
            <Route path="/quality-process" element={<QualityProcess />} />
            <Route path="/global-network" element={<GlobalNetwork />} />
            <Route path="/global-network/:location" element={<GlobalNetwork />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <StickyMobileCTA />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
